(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 40167:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(35085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 33177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7425);
/* harmony import */ var components_shared_ButtonLink_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8536);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99655);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23357);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39105);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2784);
/* harmony import */ var services_service_event_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(27862);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62177);













var BlogCta = function() {
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_6__/* .useI18n */ .Q)("blog").t;
    var locale = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_9__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_5__/* .LoggedUserContext */ .Vi), user = ref.user, loadingUser = ref.loadingUser;
    if (user || loadingUser) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledCta */ .B, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Heading3 */ .aC, {
                editorial: true,
                children: t("cta.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: t("cta.desc")
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_marketingSite_shared_Cta_styled__WEBPACK_IMPORTED_MODULE_2__/* .StyledActions */ .V, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_8___default()), {
                    href: "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_11__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_11__/* .APP_URLS.join */ .uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_shared_ButtonLink_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .C, {
                        variant: "brandTalent",
                        sizes: "md",
                        onClick: function(e) {
                            return services_service_event_tracking__WEBPACK_IMPORTED_MODULE_10__/* ["default"].trackExternalLandingCtaClicked */ .Z.trackExternalLandingCtaClicked(e, "".concat((0,utils_app_urls__WEBPACK_IMPORTED_MODULE_11__/* .getAppUrl */ .TI)(utils_app_urls__WEBPACK_IMPORTED_MODULE_11__/* .APP_URLS.join */ .uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"), "footer-blog");
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                                icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_12__/* .faUserAstronaut */ .KCX
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: t("cta.action")
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCta);


/***/ }),

/***/ 7425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ StyledCta; },
/* harmony export */   "V": function() { return /* binding */ StyledActions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99655);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  text-align: center;\n\n  ",
        " {\n    margin-bottom: ",
        ";\n  }\n\n  > p {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  > * {\n    flex-basis: 75%;\n  }\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCta = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-36107843-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl4"), components_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("lg"));
var StyledActions = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-36107843-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .container */ .nC)("md"));


/***/ }),

/***/ 17975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fo": function() { return /* binding */ StyledFormGroupContent; },
/* harmony export */   "OQ": function() { return /* binding */ StyledFormGroupField; },
/* harmony export */   "S0": function() { return /* binding */ StyledFormGroupLabelExtra; },
/* harmony export */   "Xq": function() { return /* binding */ StyledHelpIcon; },
/* harmony export */   "Z2": function() { return /* binding */ StyledFormGroupLabelWrapper; },
/* harmony export */   "Zm": function() { return /* binding */ StyledBottomAction; },
/* harmony export */   "dS": function() { return /* binding */ StyledFormGroup; },
/* harmony export */   "fI": function() { return /* binding */ StyledFormGroupSuccess; },
/* harmony export */   "jN": function() { return /* binding */ StyledFormGroupError; },
/* harmony export */   "kI": function() { return /* binding */ StyledFormGroupLabel; },
/* harmony export */   "nX": function() { return /* binding */ StyledFormGroupSpinnerSlot; },
/* harmony export */   "qB": function() { return /* binding */ StyledHint; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34956);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -",
        ";\n  left: 0;\n  z-index: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      align-items: center;\n      gap: ",
        ";\n\n      ",
        " {\n        margin-bottom: 0;\n        margin-right: ",
        ";\n      }\n\n      ",
        " {\n        margin-top: 0;\n      }\n\n      input {\n        flex-grow: 1;\n        width: auto;\n      }\n\n      ",
        " {\n        display: flex;\n        align-items: center;\n        padding-top: ",
        ";\n        padding-bottom: ",
        ";\n      }\n\n      ",
        " {\n        width: auto;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: ",
        ";\n\n  &.muted {\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      display: flex;\n      gap: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M8 10.7097C7.50116 10.7097 7.09677 11.1141 7.09677 11.6129C7.09677 12.1117 7.50116 12.5161 8 12.5161C8.49884 12.5161 8.90323 12.1117 8.90323 11.6129C8.90323 11.1141 8.49884 10.7097 8 10.7097ZM8.24742 9.93548H7.73129C7.51752 9.93548 7.34419 9.76216 7.34419 9.54839V9.5361C7.34419 7.26697 9.84226 7.48387 9.84226 6.07132C9.84226 5.42564 9.26932 4.77419 7.98935 4.77419C7.04923 4.77419 6.56145 5.08545 6.07932 5.69974C5.95326 5.86039 5.72274 5.89313 5.55519 5.77639L5.13152 5.48123C4.95006 5.35481 4.91023 5.10152 5.04619 4.92713C5.7309 4.04884 6.54329 3.48387 7.98935 3.48387C9.6771 3.48387 11.1326 4.44358 11.1326 6.07132C11.1326 8.24597 8.63452 8.13097 8.63452 9.5361V9.54839C8.63452 9.76216 8.46119 9.93548 8.24742 9.93548ZM8 1.03226C11.8265 1.03226 14.9677 4.13145 14.9677 8C14.9677 11.8481 11.8513 14.9677 8 14.9677C4.15342 14.9677 1.03226 11.8528 1.03226 8C1.03226 4.15474 4.14845 1.03226 8 1.03226ZM8 0C3.58203 0 0 3.58332 0 8C0 12.4193 3.58203 16 8 16C12.418 16 16 12.4193 16 8C16 3.58332 12.418 0 8 0Z' fill='%2330ABD5' /%3E%3C/svg%3E\");\n  height: ",
        ";\n  width: ",
        ";\n  display: inline-block;\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  justify-content: flex-start;\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  svg {\n    width: ",
        ";\n    height: ",
        ";\n    margin-right: ",
        ";\n    margin-top: 2px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}



var StyledFormGroupLabelWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-0"
})(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupSpinnerSlot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-1"
})(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .zindex */ .Y0)("spinnerSlot"));
var StyledBottomAction = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-2"
})(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
var StyledHint = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-3"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("text_subtle"));
var StyledFormGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-4"
})(_templateObject5(), function(param) {
    var inline = param.inline;
    return inline && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledFormGroupLabelWrapper, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), StyledBottomAction, StyledFormGroupContent, (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), components_shared_Select_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledSelect */ .Q);
});
var StyledFormGroupLabel = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-5"
})(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupField = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-6"
})(_templateObject8(), function(param) {
    var withAppend = param.withAppend;
    return withAppend && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"));
});
var StyledFormGroupContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5dc5d8fe-7"
})(_templateObject9());
var StyledHelpIcon = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-8"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"));
var StyledFormGroupLabelExtra = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-5dc5d8fe-9"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("midnight_500"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontWeight */ .Ue)("medium"));
var StyledFormGroupError = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-10"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("negative_500"));
var StyledFormGroupSuccess = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-5dc5d8fe-11"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_2__/* .color */ .$_)("positive_500"));


/***/ }),

/***/ 74993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9725);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49929);
/* harmony import */ var hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39105);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17975);
/* harmony import */ var _HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73091);






var FormGroup = function(param) {
    var label = param.label, children = param.children, error = param.error, forId = param.forId, className = param.className, labelExtra = param.labelExtra, bottomAction = param.bottomAction, _isLabelMuted = param.isLabelMuted, isLabelMuted = _isLabelMuted === void 0 ? false : _isLabelMuted, _inline = param.inline, inline = _inline === void 0 ? false : _inline, style = param.style, success = param.success, helpContent = param.helpContent, _isLabelHidden = param.isLabelHidden, isLabelHidden = _isLabelHidden === void 0 ? false : _isLabelHidden, hint = param.hint, append = param.append, spinnerSlot = param.spinnerSlot;
    var t = (0,hooks_useI18n__WEBPACK_IMPORTED_MODULE_2__/* .useI18n */ .Q)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroup */ .dS, {
        className: className,
        style: style,
        inline: inline,
        children: [
            (label || labelExtra) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelWrapper */ .Z2, {
                className: "".concat(isLabelHidden ? "sr-only" : ""),
                children: [
                    label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabel */ .kI, {
                        htmlFor: forId,
                        className: "".concat(isLabelMuted ? "muted" : "", " ").concat(isLabelHidden ? "sr-only" : ""),
                        children: label
                    }),
                    helpContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelpTooltip_HelpTooltip__WEBPACK_IMPORTED_MODULE_4__/* .HelpTooltip */ .k, {
                        message: helpContent
                    }),
                    labelExtra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupLabelExtra */ .S0, {
                        children: labelExtra
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupField */ .OQ, {
                withAppend: !!append,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupContent */ .Fo, {
                        children: children
                    }),
                    append
                ]
            }),
            hint && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledHint */ .qB, {
                children: hint
            }),
            bottomAction && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledBottomAction */ .Zm, {
                children: bottomAction
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupError */ .jN, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faTimesCircle */ .nYk
                    }),
                    t(error)
                ]
            }),
            success && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSuccess */ .fI, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_5__/* .faCheckCircle */ .f8k
                    }),
                    success
                ]
            }),
            spinnerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_3__/* .StyledFormGroupSpinnerSlot */ .nX, {
                children: spinnerSlot
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormGroup);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 73091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ HelpTooltip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17975);
/* harmony import */ var _TooltipMF__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83885);



var HelpTooltip = function(param) {
    var message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TooltipMF__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        content: message,
        type: "full-content",
        direction: "up",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FormGroup_styled__WEBPACK_IMPORTED_MODULE_1__/* .StyledHelpIcon */ .Xq, {})
    });
};


/***/ }),

/***/ 34956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ StyledSelect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-color: ",
        " !important;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: ",
        ";\n      font-size: ",
        ";\n      height: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      opacity: 1;\n      pointer-events: none;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n      background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730957H7.46171C7.94067 0.730957 8.18015 1.30948 7.84111 1.64852L4.38075 5.11158C4.17087 5.32146 3.82913 5.32146 3.61925 5.11158L0.158886 1.64852C-0.180154 1.30948 0.0593268 0.730957 0.538289 0.730957Z' fill='%23DEDCE4'/%3E%3C/svg%3E%0A\");\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  appearance: none;\n  min-width: ",
        ";\n  height: 3.5rem;\n  padding: 1rem 3.25rem 1rem 1.25rem;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid ",
        ";\n  transition: 0.3s;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.538289 0.730988H7.46171C7.94067 0.730988 8.18015 1.30951 7.84111 1.64855L4.38075 5.11161C4.17087 5.32149 3.82913 5.32149 3.61925 5.11161L0.158886 1.64855C-0.180154 1.30951 0.0593268 0.730988 0.538289 0.730988Z' fill='%23353241'/%3E%3C/svg%3E%0A\");\n  background-repeat: no-repeat;\n  background-position: right ",
        " top 50%;\n  background-size: 0.65em auto;\n  background-color: ",
        ";\n\n  ",
        "\n\n  ",
        "\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:hover {\n    border-color: ",
        ";\n  }\n\n  &:focus {\n    outline: 0;\n    border-color: ",
        ";\n    box-shadow: 0 0 0 4px ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var roleVariants = {
    error: {
        borderColor: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("negative_700")
    }
};
var sizeVariants = {
    sm: {
        padding: "0.25rem 0.75rem",
        fontSize: (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xs"),
        height: "2.5rem"
    }
};
var StyledSelect = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-8861b5b9-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl6"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("sans"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("medium"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_default"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .radius */ .q0)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("white"), function(param) {
    var variant = param.variant;
    return variant && roleVariants[variant] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), roleVariants[variant].borderColor);
}, function(param) {
    var sizes = param.sizes;
    return sizes && sizeVariants[sizes] && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), sizeVariants[sizes].padding, sizeVariants[sizes].fontSize, sizeVariants[sizes].height);
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_400"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_850"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), function(param) {
    var disabled = param.disabled;
    return disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_150"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("midnight_200"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("text_disabled"));
});


/***/ }),

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E$": function() { return /* binding */ StyledCopyWrapper; },
/* harmony export */   "It": function() { return /* binding */ StyledShareModalButtons; },
/* harmony export */   "ao": function() { return /* binding */ StyledCopyAnchor; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-bottom: ",
        ";\n\n  > *:not(:last-child) {\n    margin-right: ",
        ";\n  }\n\n  @media (max-width: ",
        ") {\n    flex-wrap: wrap;\n    > * {\n      width: 2.5rem;\n      height: 2.5rem;\n\n      svg {\n        width: ",
        ";\n        height: ",
        ";\n      }\n\n      &:not(:last-child) {\n        margin-right: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  padding-right: 2rem;\n  line-height: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledShareModalButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-0"
})(_templateObject(), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("mdMax"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("lg"), (0,theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("md"));
var StyledCopyAnchor = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-724ab933-1"
})(_templateObject1());
var StyledCopyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-724ab933-2"
})(_templateObject2());


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 35085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/shared/HeadMetadataLangAlternate.tsx
var HeadMetadataLangAlternate = __webpack_require__(21646);
// EXTERNAL MODULE: ./context/slugs/slugs.context.tsx
var slugs_context = __webpack_require__(18694);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(86741);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-light-svg-icons/index.mjs
var pro_light_svg_icons = __webpack_require__(38914);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./components/marketingSite/blog/BlogCta.tsx
var BlogCta = __webpack_require__(33177);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/next/dist/client/router.js
var router = __webpack_require__(93642);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogRegisterCta.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  color: ",
        ";\n  background-image: ",
        ";\n  background-size: cover;\n  background-position: left 0;\n  background-repeat: no-repeat;\n\n  @media (max-width: ",
        ") {\n    background-size: unset;\n    background-position: left 5% bottom;\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n    padding-left: 140px;\n    padding-right: ",
        ";\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n\n    @media (max-width: ",
        ") {\n      padding: ",
        ";\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  text-transform: uppercase;\n  line-height: 1.2;\n  font-weight: ",
        ";\n  color: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    text-transform: unset;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledCta = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3371682e-0"
})(_templateObject(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("indigo_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl8"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* color */.$_)("text_white"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/blog/register-cta-bg.svg"), "')");
}, (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl"), ButtonLink_styled/* default */.C, (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("xs"));
var StyledTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3371682e-1"
})(_templateObject1(), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("sm"));

;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogRegisterCta.tsx











var BlogRegisterCta = function() {
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCta, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: t("registerCTA.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading5 */.by, {
                as: "p",
                children: t("registerCTA.desc")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                    variant: "brandTalent",
                    sizes: "sm",
                    onClick: function(e) {
                        return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-blog"), "footer-blog");
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("registerCTA.cta")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var blog_BlogRegisterCta = (BlogRegisterCta);

// EXTERNAL MODULE: ./components/shared/Badge.styled.tsx
var Badge_styled = __webpack_require__(71487);
// EXTERNAL MODULE: ./components/shared/Button.js
var Button = __webpack_require__(15659);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./components/shared/Button.styled.tsx
var Button_styled = __webpack_require__(59760);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogFloatingCta.styled.tsx

function BlogFloatingCta_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 0;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        " ",
        " ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.25;\n  background-image: ",
        ";\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  &::before {\n    content: '';\n    width: 204px;\n    height: 173px;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translate(-50%, -60%);\n    background-image: ",
        ";\n  }\n\n  ",
        " {\n    position: absolute;\n    top: ",
        ";\n    right: ",
        ";\n  }\n\n  ",
        " {\n    &::before {\n      left: 0;\n      transform: unset;\n    }\n  }\n"
    ]);
    BlogFloatingCta_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var BlogFloatingCta_styled_StyledCta = styled_components_browser_esm/* default.aside.withConfig */.ZP.aside.withConfig({
    componentId: "sc-5fdf1eb0-0"
})(BlogFloatingCta_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), (0,theme/* radius */.q0)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontWeight */.Ue)("medium"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/blog/floating-cta-bg.svg"), "')");
}, function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/blog/floating-cta-image.svg"), "')");
}, Button_styled/* default */.Z, (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), Typography_styled/* Heading3 */.aC);

;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogFloatingCta.tsx















var SESSION_HIDE_BLOG_FLOATING_CTA = "SESSION_HIDE_BLOG_FLOATING_CTA";
var BlogFloatingCta = function() {
    var closeBanner = function closeBanner() {
        var ref;
        setIsBannerClosed(true);
        window === null || window === void 0 ? void 0 : (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.setItem(SESSION_HIDE_BLOG_FLOATING_CTA, "true");
    };
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,react.useState)(false), isBannerClosed = ref1[0], setIsBannerClosed = ref1[1];
    (0,react.useEffect)(function() {
        var ref;
        setIsBannerClosed((window === null || window === void 0 ? void 0 : (ref = window.sessionStorage) === null || ref === void 0 ? void 0 : ref.getItem(SESSION_HIDE_BLOG_FLOATING_CTA)) === "true");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isBannerClosed && !user && !loadingUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlogFloatingCta_styled_StyledCta, {
            role: "complementary",
            "aria-live": "polite",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_styled/* default */.Z, {
                    variant: "tertiary",
                    sizes: "sm",
                    isIcon: true,
                    onClick: closeBanner,
                    "aria-label": t("floatingCTA.close"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: pro_light_svg_icons/* faTimes */.NBC
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading3 */.aC, {
                    editorial: true,
                    as: "p",
                    children: t("floatingCTA.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("floatingCTA.desc")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=floating-blog"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                        variant: "brandTalent",
                        sizes: "md",
                        onClick: function(e) {
                            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=floating-blog"), "floating-blog");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faCheckCircle */.f8k
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("floatingCTA.cta")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var blog_BlogFloatingCta = (BlogFloatingCta);

// EXTERNAL MODULE: ./components/marketingSite/shared/Cta.styled.tsx
var Cta_styled = __webpack_require__(7425);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogPostComponent.styled.tsx

function BlogPostComponent_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    BlogPostComponent_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogPostComponent_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        " ",
        ";\n  max-width: ",
        ";\n  margin: auto;\n  width: 100%;\n\n  ",
        " {\n    margin-top: ",
        ";\n  }\n"
    ]);
    BlogPostComponent_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        ";\n\n  ",
        " {\n    margin-bottom: ",
        ";\n    text-align: left;\n\n    &:before {\n      left: 0;\n      transform: unset;\n    }\n\n    @media (min-width: ",
        ") {\n      text-align: center;\n\n      &:before {\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    justify-content: center;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  span {\n    display: inline-block;\n    color: ",
        ";\n    background-color: ",
        ";\n    padding: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto ",
        " auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: block;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  p,\n  ul,\n  ol,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  img,\n  blockquote {\n    max-width: ",
        ";\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  img {\n    display: block;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    width: 100%;\n  }\n\n  h2 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.17;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h3 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.12;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h4 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h5 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  h6 {\n    font-family: ",
        ";\n    font-weight: ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  ul {\n    list-style-type: disc;\n    padding-left: 1em;\n  }\n\n  ol {\n    padding-left: 1em;\n  }\n\n  li {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    list-style: inherit;\n  }\n\n  table {\n    max-width: ",
        ";\n    font-size: ",
        ";\n    border-radius: ",
        ";\n    box-shadow: ",
        ";\n    display: block;\n    overflow-x: auto;\n  }\n\n  tbody {\n    width: 100%;\n    display: table;\n  }\n\n  tr:nth-child(1n) {\n    background: ",
        ";\n  }\n\n  td {\n    padding: ",
        " ",
        ";\n    text-align: left;\n    white-space: nowrap;\n\n    &.has-text-align-center {\n      text-align: center;\n    }\n  }\n\n  .wp-block-table {\n    margin: ",
        " 0;\n    overflow-x: auto;\n    padding: ",
        " ",
        ";\n\n    table {\n      border-collapse: collapse;\n      width: 100%;\n    }\n\n    tr:nth-child(odd) {\n      background: ",
        ";\n    }\n  }\n\n  .wp-block-image,\n  .wp-caption {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    display: block;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n\n    .size-medium {\n      max-width: ",
        ";\n    }\n\n    img {\n      border: 0;\n      margin: 0;\n      border-radius: 0;\n    }\n\n    figcaption {\n      text-align: left;\n      padding-top: ",
        ";\n    }\n\n    a {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n\n      &:active {\n        color: ",
        ";\n      }\n    }\n  }\n\n  .wp-block-group {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    display: block;\n\n    iframe {\n      border: 0;\n    }\n  }\n\n  .wp-block-video {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n\n    video {\n      width: 100%;\n    }\n  }\n\n  .wp-block-embed-youtube {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n\n    .wp-block-embed__wrapper {\n      position: relative;\n      padding-bottom: 56.25%;\n      height: 0;\n      overflow: hidden;\n      max-width: 100%;\n    }\n\n    iframe {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .wp-block-embed-arcade {\n    max-width: ",
        ";\n    margin: ",
        " auto;\n    border: ",
        " solid ",
        ";\n    border-radius: ",
        ";\n    background-color: ",
        ";\n\n    .wp-block-embed__wrapper {\n      position: relative;\n      padding-bottom: 52.75%;\n      height: 0;\n      overflow: hidden;\n      max-width: 100%;\n      background-color: ",
        ";\n\n      @media (max-width: ",
        ") {\n        padding-bottom: 62%;\n      }\n    }\n\n    iframe {\n      border: 0;\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .wp-block-spacer {\n    display: none;\n  }\n\n  .has-inline-color {\n    color: inherit !important;\n  }\n\n  *[style*='color'] {\n    color: inherit !important;\n  }\n\n  .wp-block-quote,\n  .twitter-tweet {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n    padding-left: ",
        ";\n    border-left: ",
        " solid ",
        ";\n  }\n\n  .instagram-media {\n    margin: ",
        " auto !important;\n  }\n\n  .wp-block-buttons {\n    &.is-layout-flex {\n      display: flex;\n      align-items: center;\n    }\n    &.is-content-justification-center {\n      justify-content: center;\n    }\n  }\n\n  .wp-block-button {\n    margin-top: ",
        ";\n\n    &__link {\n      background-color: ",
        " !important;\n      color: ",
        " !important;\n      font-size: ",
        " !important;\n      text-transform: uppercase !important;\n      font-weight: ",
        " !important;\n      padding: ",
        " ",
        " !important;\n      border-radius: ",
        " !important;\n      transition: 0.3s !important;\n      display: inline-block;\n      text-align: center;\n\n      &:hover,\n      &:active {\n        background-color: ",
        " !important;\n      }\n\n      &:focus {\n        outline: 0;\n        box-shadow: 0 0 0 4px ",
        ";\n        color: ",
        " !important;\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        ";\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: ",
        " auto;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: ",
        ";\n\n  @media (max-width: ",
        ") {\n    justify-content: center;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2.5rem;\n  height: 2.5rem;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  color: ",
        ";\n  transition: 0.3s;\n\n  svg {\n    width: 2.5rem !important;\n    height: 2.5rem;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  background-color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  transition: 0.3s;\n  width: 18rem;\n  font-weight: ",
        ";\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n\n  &.next {\n    text-align: right;\n    align-items: flex-end;\n  }\n\n  &:hover {\n    background-color: ",
        ";\n    color: inherit;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 20.5rem;\n  position: sticky;\n  left: calc(50% + ",
        " / 2 + ",
        ");\n  bottom: ",
        ";\n  margin-bottom: ",
        ";\n  margin-right: ",
        ";\n\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-0"
})(BlogPostComponent_styled_templateObject());
var StyledPost = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-3e8f7e98-1"
})(BlogPostComponent_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"), Cta_styled/* StyledCta */.B, (0,theme/* spacing */.W0)("xl5"));
var StyledPostHeader = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-3e8f7e98-2"
})(_templateObject2(), (0,theme/* spacing */.W0)("xl3"), Typography/* Heading1 */.nL, (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"));
var StyledPostInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-3"
})(_templateObject3(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"));
var StyledPostOneLang = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-3e8f7e98-4"
})(_templateObject4(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledPostInfoFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-5"
})(_templateObject5(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"));
var StyledPostHero = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-3e8f7e98-6"
})(_templateObject6(), (0,theme/* spacing */.W0)("xl3"));
var StyledPostContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl4"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl3"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl2"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl"), (0,theme/* fontFamily */.I8)("serif"), (0,theme/* fontWeight */.Ue)("bold"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* container */.nC)("xl"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* radius */.q0)("md"), (0,theme/* shadow */.AF)("md"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("link_inverse"), (0,theme/* color */.$_)("link_inverse_hover"), (0,theme/* color */.$_)("link_inverse_active"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("text_default"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("emerald_400"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("emerald_600"), (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* radius */.q0)("md"), (0,theme/* color */.$_)("emerald_400"), (0,theme/* color */.$_)("midnight_150"), (0,theme/* color */.$_)("midnight_150"));
var StyledPostTags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-8"
})(_templateObject8(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"));
var StyledRecommendations = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3e8f7e98-9"
})(_templateObject9(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl4"));
var StyledComments = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3e8f7e98-10"
})(_templateObject10(), (0,theme/* container */.nC)("sm"), (0,theme/* spacing */.W0)("xl4"));
var StyledPostNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-11"
})(_templateObject11(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("mdMax"), (0,theme/* spacing */.W0)("md"));
var StyledPostNavItemButton = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3e8f7e98-12"
})(_templateObject12(), (0,theme/* color */.$_)("midnight_800"));
var StyledPostNavHint = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-3e8f7e98-13"
})(_templateObject13(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("black"));
var StyledPostNavItemTop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-14"
})(_templateObject14(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"));
var StyledPostNavItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-3e8f7e98-15"
})(_templateObject15(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* color */.$_)("midnight_150"));
var StyledFloatingBannerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3e8f7e98-16"
})(_templateObject16(), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("mdMax"));

// EXTERNAL MODULE: ./components/shared/ShareModal/ShareModal.styled.ts
var ShareModal_styled = __webpack_require__(80087);
// EXTERNAL MODULE: ./components/shared/TooltipMF.tsx
var TooltipMF = __webpack_require__(83885);
// EXTERNAL MODULE: ../../node_modules/react-modal/lib/index.js
var lib = __webpack_require__(37149);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./components/shared/FormGroup.tsx
var FormGroup = __webpack_require__(74993);
// EXTERNAL MODULE: ./components/shared/InputText.tsx
var InputText = __webpack_require__(6776);
// EXTERNAL MODULE: ./components/shared/Modal.tsx
var Modal = __webpack_require__(61897);
;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogShareModal.tsx









var BlogShareModal = function(param) {
    var shareModalIsOpen = param.shareModalIsOpen, shareModalClose = param.shareModalClose, slug = param.slug;
    var linkInputRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), copied = ref[0], setCopied = ref[1];
    var ref1 = (0,react.useState)(""), baseUrl = ref1[0], setBaseUrl = ref1[1];
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    (0,react.useEffect)(function() {
        setBaseUrl("".concat(window.location.origin));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            isOpen: shareModalIsOpen,
            contentLabel: t("share.title"),
            onAfterOpen: function() {
                setCopied(false);
            },
            shouldCloseOnOverlayClick: true,
            onRequestClose: shareModalClose,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: t("share.title"),
                onClose: shareModalClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormGroup/* default */.Z, {
                        label: t("share.label"),
                        forId: "shareLink",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText/* default */.Z, {
                                id: "shareLink",
                                type: "text",
                                value: "".concat(baseUrl, "/blog/").concat(slug),
                                title: slug,
                                variant: "copy",
                                readOnly: true,
                                ref: linkInputRef,
                                onClick: function() {
                                    var ref;
                                    (ref = linkInputRef.current) === null || ref === void 0 ? void 0 : ref.select();
                                    document.execCommand("copy");
                                    setCopied(true);
                                    setTimeout(function() {
                                        setCopied(false);
                                    }, 2000);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyWrapper */.E$, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMF/* default */.Z, {
                                    content: t("share.copied"),
                                    direction: "up",
                                    distance: 65,
                                    isOpen: copied,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal_styled/* StyledCopyAnchor */.ao, {})
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var blog_BlogShareModal = (BlogShareModal);

;// CONCATENATED MODULE: ./components/marketingSite/blog/BlogPostComponent.tsx





















function getPostAuthor(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref.author;
    var author = embedded && embedded[0] ? embedded[0] : undefined;
    return author ? author.name : undefined;
}
function getPostThumb(post) {
    var ref;
    var embedded = (ref = post._embedded) === null || ref === void 0 ? void 0 : ref["wp:featuredmedia"];
    var media = embedded && embedded[0] ? embedded[0] : undefined;
    return media ? media.source_url : undefined;
}
var BlogPostComponent = function(param) {
    var _disqusShortname = param.disqusShortname, disqusShortname = _disqusShortname === void 0 ? "" : _disqusShortname, post = param.post, categories = param.categories;
    var openShareModal = function openShareModal() {
        setIsOpen(true);
    };
    var closeShareModal = function closeShareModal() {
        setIsOpen(false);
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), shareModalIsOpen = ref4[0], setIsOpen = ref4[1];
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var locale = (0,router.useRouter)().locale;
    var ref5 = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref5.user, loadingUser = ref5.loadingUser;
    var ref6 = (0,react.useContext)(slugs_context/* SlugsContext */.X), slug = ref6.slug, hasSlugForLang = ref6.hasSlugForLang;
    var ref7 = (0,react.useState)(""), origin = ref7[0], setOrigin = ref7[1];
    var options = {
        replace: function(domNode) {
            var ref;
            // @ts-expect-error don't know why, but I cannot use `domNode instanceof Element`, as stated here: https://www.npmjs.com/package/html-react-parser#migration
            if (((ref = domNode.attribs) === null || ref === void 0 ? void 0 : ref.class) === "signup-banner") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: !user && !loadingUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogRegisterCta, {})
                });
            }
        }
    };
    var postContent = (0,html_react_parser/* default */.ZP)(post.content.rendered, options);
    (0,react.useEffect)(function() {
        setOrigin(window.location.origin);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPost, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostHeader, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                                        editorial: true,
                                        children: post.title.rendered
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("post.published", {
                                                        date: new Date(post.date).toLocaleDateString(locale, {
                                                            year: "numeric",
                                                            month: "long",
                                                            day: "numeric"
                                                        }),
                                                        author: getPostAuthor(post)
                                                    })
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
                                                sizes: "sm",
                                                variant: "tertiary",
                                                onClick: openShareModal,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                        icon: free_solid_svg_icons/* faShareSquare */.tFX
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: t("post.share")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !!slug && !hasSlugForLang(locale) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostOneLang, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: locale === "en" ? t("onlyLang_es") : t("onlyLang_en")
                                        })
                                    })
                                ]
                            }),
                            getPostThumb(post) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostHero, {
                                src: getPostThumb(post),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostContent, {
                                children: postContent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostInfoFooter, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("post.published", {
                                            date: new Date(post.date).toLocaleDateString(locale, {
                                                year: "numeric",
                                                month: "long",
                                                day: "numeric"
                                            }),
                                            author: getPostAuthor(post)
                                        })
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostTags, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                        children: [
                                            t("post.tags"),
                                            ":"
                                        ]
                                    }),
                                    " ",
                                    categories === null || categories === void 0 ? void 0 : categories.filter(function(c) {
                                        return c.slug !== "uncategorised" && c.slug !== "oculto" && c.slug !== "sin-categorizar" && c.slug !== "all" && c.slug !== "todo-el-blog";
                                    }).map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/category/").concat(category.slug),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_styled/* default */.Z, {
                                                as: "a",
                                                variant: "secondary",
                                                children: category.name
                                            })
                                        }, category.id);
                                    })
                                ]
                            }),
                            (post.previous || post.next) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostNav, {
                                children: [
                                    post.previous && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/").concat((ref = post.previous) === null || ref === void 0 ? void 0 : ref.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostNavItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostNavItemTop, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostNavItemButton, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                "aria-hidden": "true",
                                                                icon: pro_light_svg_icons/* faArrowSquareLeft */.jqM
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostNavHint, {
                                                            children: t("post.prev")
                                                        })
                                                    ]
                                                }),
                                                (ref1 = post.previous) === null || ref1 === void 0 ? void 0 : ref1.title
                                            ]
                                        })
                                    }),
                                    post.next && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.blog */.uu.blog, locale), "/").concat((ref2 = post.next) === null || ref2 === void 0 ? void 0 : ref2.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostNavItem, {
                                            className: "next",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPostNavItemTop, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostNavHint, {
                                                            children: t("post.next")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPostNavItemButton, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                "aria-hidden": "true",
                                                                icon: pro_light_svg_icons/* faArrowSquareRight */.dbF
                                                            })
                                                        })
                                                    ]
                                                }),
                                                (ref3 = post.next) === null || ref3 === void 0 ? void 0 : ref3.title
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogCta/* default */.Z, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFloatingBannerContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogFloatingCta, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogShareModal, {
                slug: post.slug,
                shareModalIsOpen: shareModalIsOpen,
                shareModalClose: closeShareModal
            })
        ]
    });
};
/* harmony default export */ var blog_BlogPostComponent = (BlogPostComponent);

;// CONCATENATED MODULE: ./pages/blog/[slug].tsx












var BlogPostPage = function(props) {
    var t = (0,useI18n/* useI18n */.Q)("blog").t;
    var yoastHead = (0,html_react_parser/* default */.ZP)("".concat(props.post.yoast_head));
    var ref = (0,react.useContext)(slugs_context/* SlugsContext */.X), setSlug = ref.setSlug, clearSlug = ref.clearSlug;
    (0,usePageTrack/* usePageTrack */.N)("Blog - Page Loaded");
    (0,react.useEffect)(function() {
        setSlug(props.post.language_slugs);
        return function() {
            clearSlug();
        };
    }, [
        props.post.id
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: yoastHead
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "blogMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n            "@context": "https://schema.org",\n            "@type": "Blog",\n            "name": "'.concat(t("pageTitle"), '",\n            "url": "https://www.getmanfred.com/blog",\n            "description": "').concat(t("pageDescription"), '",\n            "publisher": {\n              "@type": "Organization",\n              "name": "Manfred",\n              "logo": {\n                "@type": "ImageObject",\n                "url": "https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000",\n                "width": 200,\n                "height": 50\n              }\n            }\n          }')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadataLangAlternate/* default */.Z, {
                url: app_urls/* APP_URLS.blog */.uu.blog,
                path: {
                    ES: "".concat(props.post.slug),
                    EN: "".concat(props.post.slug)
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogPostComponent, (0,_object_spread/* default */.Z)({}, props))
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (BlogPostPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,4115,9161,9092,9774,2888,179], function() { return __webpack_exec__(40167); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);